module.exports = __webpack_public_path__ + "img/9.3e2a4015.webp";